var _mask, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_56919_46296",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#070038"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20M40 20M40 20M0 20M20 0M40 20M20 40M0 20M20 40V38C10.0589 38 2 29.9411 2 20H0H-2C-2 32.1503 7.84974 42 20 42V40ZM40 20H38C38 29.9411 29.9411 38 20 38V40V42C32.1503 42 42 32.1503 42 20H40ZM20 0V2C29.9411 2 38 10.0589 38 20H40H42C42 7.84974 32.1503 -2 20 -2V0ZM20 0V-2C7.84974 -2 -2 7.84974 -2 20H0H2C2 10.0589 10.0589 2 20 2V0Z",
    fill: "#00E387",
    mask: "url(#path-1-inside-1_56919_46296)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7261 16.328C22.7261 16.748 22.6661 17.09 22.5461 17.354C22.4261 17.618 22.1921 17.81 21.8441 17.93V18.038C22.1921 18.158 22.4261 18.338 22.5461 18.578C22.6661 18.806 22.7261 19.124 22.7261 19.532V21.962C22.7261 22.898 22.4861 23.6 22.0061 24.068C21.5261 24.536 20.8601 24.77 20.0081 24.77C19.1561 24.77 18.4841 24.536 17.9921 24.068C17.5121 23.588 17.2721 22.886 17.2721 21.962V19.604H19.6841V22.322C19.6841 22.67 19.7921 22.844 20.0081 22.844C20.2121 22.844 20.3141 22.67 20.3141 22.322V19.838C20.3141 19.49 20.2781 19.262 20.2061 19.154C20.1341 19.034 19.9601 18.974 19.6841 18.974H19.1261V17.048H19.6841C19.9601 17.048 20.1341 16.994 20.2061 16.886C20.2781 16.778 20.3141 16.55 20.3141 16.202V14.078C20.3141 13.73 20.2121 13.556 20.0081 13.556C19.7921 13.556 19.6841 13.73 19.6841 14.078V16.418H17.2721V14.42C17.2721 13.508 17.5121 12.818 17.9921 12.35C18.4841 11.87 19.1561 11.63 20.0081 11.63C20.8601 11.63 21.5261 11.864 22.0061 12.332C22.4861 12.8 22.7261 13.496 22.7261 14.42V16.328Z",
    fill: "#00E387"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree);
export default __webpack_public_path__ + "static/media/three.d569f302e3786557f11cd8454b0143bf.svg";
export { ForwardRef as ReactComponent };